import { render } from "./MixModal.vue?vue&type=template&id=2592c17a&scoped=true"
import script from "./MixModal.vue?vue&type=script&lang=js"
export * from "./MixModal.vue?vue&type=script&lang=js"

import "./MixModal.vue?vue&type=style&index=0&id=2592c17a&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2592c17a"]])

export default __exports__